import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d2a4de34b9ae0014a6a943/gorgisairheat/src/app/page.tsx");
